import { Shield } from "lucide-react";
import { useCurrentUser } from "../auth/useCurrentUser";
import { H4 } from "@/components/ui/typography";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ROLE_NAMES } from "@/utils/constant";

export default function RoleAccordion() {
  const { roles } = useCurrentUser();

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value={"clusterSummary"}>
        <AccordionTrigger>
          <div className="col-span-2 flex items-center gap-2">
            <Shield />
            <H4>User Roles</H4>
          </div>
        </AccordionTrigger>
        <AccordionContent>
          <table className="w-full table-auto">
            <thead className="border-b-2">
              <tr>
                <th className="w-1 p-4 text-left text-sm font-medium">No</th>
                <th className=" p-4 text-left text-sm font-medium">Role</th>
              </tr>
            </thead>
            <tbody>
              {roles?.map((role, index) => (
                <tr key={index} className="border-b">
                  <td className=" p-4 text-sm">{index + 1}</td>
                  <td className=" p-4 text-sm">
                    <span className="flex w-min items-center gap-x-1 rounded-full bg-blue-50 px-2 py-1 font-medium text-blue-600">
                      <Shield className="h-4 w-4" />
                      <p className="whitespace-nowrap">
                        {ROLE_NAMES[role as keyof typeof ROLE_NAMES] ?? role}
                      </p>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
